export default "__VITE_ASSET__BBJusP4j__"